import { AxiosResponse } from 'axios';
import { call, CallEffect, PutEffect, select } from 'redux-saga/effects';
import { Action } from 'redux-saga';
import { ReducersTypes } from '@/redux/reducers/Models';
import { automaticApi } from '@/settings/api';
import { getFormattedDeviceFingerPrintID } from '@/utils/functions';

export interface Fetch {
    visitorId: string;
    password: string;
    callback: (success: boolean, errorMessage?: string) => void;
}

export interface CreateCredentialsAction {
    type: string;
    payload: Fetch;
}

const uri = "/pedido/v1/criarlogin";
const uriAuthorization = "/pedido/v1/pagamentoautorizacao";
const uriPayment = "/pedido/v1/pagamento";

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* createCredentials({
    payload,
}: CreateCredentialsAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomerReducer);

        const body = {
            pedido: customer?.register?.orderId,
            email: customer?.register?.email,
            senha: payload.password,
        }

        const response: AxiosResponse = yield call(automaticApi.post, uri, body)
        const responseData = response?.data;

        if (responseData?.status?.codigoRetorno === 0) {

            const deviceFingerprintID = getFormattedDeviceFingerPrintID(payload.visitorId ?? "");
            
            const responseAuthorization: AxiosResponse = yield call(automaticApi.post, uriAuthorization, {
                identificadorStatus: "30",
                pedido: body.pedido,
                deviceFingerprintID,
            });

            const responsePaymentFirstStep: AxiosResponse = yield call(automaticApi.post, uriPayment, {
                identificadorStatus: "40",
                pedido: body.pedido,
            });

            const responsePaymentSecondStep: AxiosResponse = yield call(automaticApi.post, uriPayment, {
                identificadorStatus: "50",
                isAcceptedTerms: true,
                isAcceptedPrivacy: true,
                pedido: body.pedido,
            });

            const responsePaymentThirdStep: AxiosResponse = yield call(automaticApi.post, uriPayment, {
                identificadorStatus: "60",
                pedido: body.pedido,
            });

            if (responseAuthorization?.data?.status?.codigoRetorno === 0 &&
                responsePaymentFirstStep?.data?.status?.codigoRetorno === 0 &&
                responsePaymentSecondStep?.data?.status?.codigoRetorno === 0 &&
                responsePaymentThirdStep?.data?.status?.codigoRetorno === 0
            ) {
                yield call(
                    payload.callback, 
                    true
                );
            } else {
                yield call(
                    payload.callback, 
                    false,
                    "timeout"
                );
            }


        } else {
            yield call(
                payload.callback, 
                false,
                "already"
            );
        }
    } catch (err) {
        yield call(
            payload.callback, 
            false,
            "timeout"
        );
    }
}
